import script from "./ComSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComSideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ComSideMenu.vue?vue&type=style&index=0&id=4ae8e9c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae8e9c6"]])

export default __exports__